import React from 'react';
import { inject } from 'mobx-react';
import { MarketplaceOrderEditOrderStepTemplate } from 'themes/modules/order/pages/wizard';

@inject(i => ({
	marketplaceOrderEditViewStore: i.rootStore.marketplaceOrderEditViewStore,
}))
class MarketplaceOrderEditOrderStep extends React.Component {
	render() {
		return <MarketplaceOrderEditOrderStepTemplate {...this.props} />;
	}
}

export default MarketplaceOrderEditOrderStep;



// WEBPACK FOOTER //
// ./src/modules/order/pages/wizard/MarketplaceOrderEditOrderStep.jsx